export const isTransactionOptionsDisabled = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_DISABLE_TRANSACTION_OPTIONS' &&
      !!permission.status,
  );
};
